import React, { Fragment } from "react";
import Header from "../components/Header";
import PageHeader from "../components/PageHeader";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, isTestMode } from "../utils/init";
import { Link } from "react-router-dom";
import { showToast, showHttpError, currentPageAccess } from "../utils/library";
import {
  FetchMerchantStatus,
  GetAllMenus,
  CreateSubMerchant,
  GetSubMerchantList,
  UpdateAccessLevel,
  RemoveSubMerchant,
} from "../utils/service";
import PaybitoCaptcha from "../components/PaybitoCaptcha";
import PhoneInput from "react-phone-input-2";

const styles = {
  pageWrapper: {
    padding: "32px 24px 60px",
  },
  pageHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "28px",
    flexWrap: "wrap",
    gap: "16px",
  },
  pageHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "16px",
  },
  headerIcon: {
    width: "48px",
    height: "48px",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    color: "#7c3aed",
    background: "color-mix(in srgb, #7c3aed, transparent 88%)",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  addButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "10px 22px",
    borderRadius: "12px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow:
      "0 2px 8px color-mix(in srgb, var(--btn-color), transparent 60%)",
  },
  tableCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    overflow: "hidden",
  },
  tableCardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "20px 24px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  tableCardTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "var(--text-color)",
    margin: 0,
  },
  tableWrapper: {
    overflowX: "auto",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
  },
  th: {
    padding: "14px 24px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    color: "var(--text-color)",
    opacity: 0.5,
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
    textAlign: "left",
    whiteSpace: "nowrap",
  },
  td: {
    padding: "16px 24px",
    fontSize: "14px",
    color: "var(--text-color)",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 95%)",
    verticalAlign: "middle",
  },
  nameCell: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  avatar: {
    width: "38px",
    height: "38px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "14px",
    fontWeight: "700",
    color: "#fff",
    flexShrink: 0,
  },
  nameText: {
    fontSize: "14px",
    fontWeight: "600",
    color: "var(--text-color)",
  },
  emailText: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.6,
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
  },
  phoneText: {
    fontSize: "13px",
    color: "var(--text-color)",
    fontFamily: "'SF Mono', 'Fira Code', 'Fira Mono', monospace",
  },
  statusBadge: (status) => {
    let bg, color;
    if (status === 0) {
      bg = "color-mix(in srgb, #10b981, transparent 88%)";
      color = "#10b981";
    } else if (status === 1 || status === 40) {
      bg = "color-mix(in srgb, #ef4444, transparent 88%)";
      color = "#ef4444";
    } else if (status >= 2 && status <= 5) {
      bg = "color-mix(in srgb, #f59e0b, transparent 88%)";
      color = "#f59e0b";
    } else if (status >= 6 && status <= 7) {
      bg = "color-mix(in srgb, #3b82f6, transparent 88%)";
      color = "#3b82f6";
    } else if (status >= 8 && status <= 11) {
      bg = "color-mix(in srgb, #7c3aed, transparent 88%)";
      color = "#7c3aed";
    } else {
      bg = "color-mix(in srgb, var(--text-color), transparent 88%)";
      color = "var(--text-color)";
    }
    return {
      display: "inline-block",
      padding: "5px 12px",
      borderRadius: "20px",
      fontSize: "12px",
      fontWeight: "600",
      background: bg,
      color: color,
      whiteSpace: "nowrap",
    };
  },
  viewBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "7px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--btn-color), transparent 60%)",
    background: "color-mix(in srgb, var(--btn-color), transparent 90%)",
    color: "var(--btn-color)",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  deleteBtn: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "7px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, #ef4444, transparent 60%)",
    background: "color-mix(in srgb, #ef4444, transparent 90%)",
    color: "#ef4444",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginLeft: "8px",
  },
  emptyState: {
    textAlign: "center",
    padding: "60px 24px",
  },
  emptyIcon: {
    width: "64px",
    height: "64px",
    borderRadius: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    color: "var(--text-color)",
    opacity: 0.25,
    background: "color-mix(in srgb, var(--text-color), transparent 92%)",
    margin: "0 auto 16px",
  },
  emptyText: {
    fontSize: "15px",
    color: "var(--text-color)",
    opacity: 0.45,
    fontWeight: "500",
  },
  // Modal styles
  modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.6)",
    backdropFilter: "blur(6px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1060,
    padding: "20px",
  },
  modalContent: {
    background: "var(--body-color-less)",
    borderRadius: "20px",
    width: "100%",
    maxWidth: "580px",
    maxHeight: "85vh",
    overflowY: "auto",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 90%)",
    boxShadow: "0 24px 80px rgba(0,0,0,0.3)",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
    padding: "24px 28px 20px",
    borderBottom:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  modalIconBadge: (color) => ({
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    color: color,
    background: `color-mix(in srgb, ${color}, transparent 88%)`,
    flexShrink: 0,
  }),
  modalTitle: {
    fontSize: "18px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  modalSubtitle: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.5,
    margin: 0,
  },
  modalBody: {
    padding: "24px 28px",
  },
  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "16px",
  },
  formGroup: {
    marginBottom: "18px",
  },
  formLabel: {
    display: "block",
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.6,
    marginBottom: "8px",
  },
  formInput: {
    width: "100%",
    padding: "11px 16px",
    borderRadius: "10px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "var(--body-color-less2)",
    color: "var(--text-color)",
    fontSize: "14px",
    outline: "none",
    transition: "border-color 0.2s ease",
    boxSizing: "border-box",
  },
  passwordMatch: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontSize: "12px",
    fontWeight: "600",
    padding: "4px 12px",
    borderRadius: "8px",
    marginTop: "4px",
  },
  permissionSection: {
    marginTop: "8px",
  },
  permissionLabel: {
    fontSize: "13px",
    fontWeight: "600",
    color: "var(--text-color)",
    marginBottom: "12px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  permissionTable: {
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: "0 4px",
  },
  permTh: {
    padding: "8px 16px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.6px",
    color: "var(--text-color)",
    opacity: 0.4,
    textAlign: "left",
  },
  permTd: {
    padding: "10px 16px",
    fontSize: "13px",
    fontWeight: "500",
    color: "var(--text-color)",
    background: "var(--body-color-less2)",
  },
  permTdFirst: {
    borderRadius: "10px 0 0 10px",
  },
  permTdLast: {
    borderRadius: "0 10px 10px 0",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
    accentColor: "var(--btn-color)",
  },
  modalFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "12px",
    padding: "20px 28px 24px",
    borderTop:
      "1px solid color-mix(in srgb, var(--text-color), transparent 92%)",
  },
  btnPrimary: {
    padding: "10px 24px",
    borderRadius: "12px",
    border: "none",
    background: "var(--btn-color)",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow:
      "0 2px 8px color-mix(in srgb, var(--btn-color), transparent 60%)",
  },
  btnCancel: {
    padding: "10px 24px",
    borderRadius: "12px",
    border: "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
    background: "transparent",
    color: "var(--text-color)",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

const STATUS_MAP = {
  0: "Account Unlocked",
  1: "Account Disabled",
  2: "Account Opened",
  3: "Email Confirmed",
  4: "Bank Verification Pending",
  5: "Bank Verified",
  6: "Basic Verification Requested",
  7: "Basic Verification Success",
  8: "Business Plan Requested",
  9: "Business Plan Activated",
  10: "Enterprise Plan Requested",
  11: "Enterprise Plan Activated",
  40: "Account Deleted",
};

const AVATAR_COLORS = [
  "#7c3aed",
  "#3b82f6",
  "#10b981",
  "#f59e0b",
  "#ef4444",
  "#ec4899",
  "#06b6d4",
  "#8b5cf6",
];

class UserManagement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      pageNo: 1,
      noOfItemsPerPage: 20,
      showAddUserPopup: false,
      showEditUserPopup: false,
      showDeletePopup: false,
      selectedDeleteMerchant: null,
      updateAccessLevel: "",
      menus: [],
      phone: "",
      gender: "Male",
      dialCode: "1",
      selectedCountry: "us",
      showPassword: false,
      showConfirmPassword: false,
      isPasswordMatched: null,
      subMerchants: [],
      permission: "WRITE",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      confirmPassword: "",
      errors: {},
    };
  }

  // Regex patterns from PROMPT.txt
  nameRegex = /^[A-Za-z\s-]{2,50}$/;
  passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@.!])[A-Za-z\d$@.!]{8,35}$/;
  emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  phoneRegex = /^\d{7,15}$/;

  validateField = (name, value) => {
    let errors = { ...this.state.errors };
    let msg = "";

    switch (name) {
      case "firstName":
        if (!value) msg = "First name is required";
        else if (value.length < 2) msg = "Minimum length: 2 characters";
        else if (value.length > 50) msg = "Maximum length: 50 characters";
        else if (!this.nameRegex.test(value))
          msg = "Invalid characters in name";
        break;
      case "lastName":
        if (!value) msg = "Last name is required";
        else if (value.length < 2) msg = "Minimum length: 2 characters";
        else if (value.length > 50) msg = "Maximum length: 50 characters";
        else if (!this.nameRegex.test(value))
          msg = "Invalid characters in name";
        break;
      case "email":
        if (!value) msg = "Email is required";
        else if (value.length > 254) msg = "Maximum length: 254 characters";
        else if (!this.emailRegex.test(value)) msg = "Invalid email format";
        break;
      case "password":
        if (!value) msg = "Password is required";
        else if (!this.passwordRegex.test(value)) {
          msg =
            "The password should be minimum 8 and maximum 35 characters and must contain at least one uppercase, one lowercase, one number and one special character ($ @ . ! only).";
        }
        break;
      case "confirmPassword":
        if (!value) msg = "Confirm password is required";
        else if (value !== this.state.password) msg = "Passwords do not match";
        break;
      default:
        break;
    }

    if (msg) errors[name] = msg;
    else delete errors[name];

    this.setState({ errors });
    return msg === "";
  };

  handleFirstNameChange = (e) => {
    const value = e.target.value;
    // Prevent typing characters not allowed by regex: Alphabets, Spaces, Hyphen
    const filteredValue = value.replace(/[^A-Za-z\s-]/g, "");
    if (filteredValue.length <= 50) {
      this.setState({ firstName: filteredValue }, () => {
        this.validateField("firstName", filteredValue);
      });
    }
  };

  handleLastNameChange = (e) => {
    const value = e.target.value;
    // Prevent typing characters not allowed by regex: Alphabets, Spaces, Hyphen
    const filteredValue = value.replace(/[^A-Za-z\s-]/g, "");
    if (filteredValue.length <= 50) {
      this.setState({ lastName: filteredValue }, () => {
        this.validateField("lastName", filteredValue);
      });
    }
  };

  handleEmailChange = (e) => {
    const value = e.target.value;
    if (value.length <= 254) {
      this.setState({ email: value }, () => {
        this.validateField("email", value);
      });
    }
  };

  handlePasswordChange = (e) => {
    const value = e.target.value;
    // Prevent typing characters not allowed: A-Z, a-z, 0-9, $, @, ., !
    const filteredValue = value.replace(/[^A-Za-z\d$@.!]/g, "");
    if (filteredValue.length <= 35) {
      this.setState({ password: filteredValue }, () => {
        this.validateField("password", filteredValue);
        if (this.state.confirmPassword) {
          this.validateField("confirmPassword", this.state.confirmPassword);
        }
      });
    }
  };

  handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    if (value.length <= 35) {
      this.setState({ confirmPassword: value }, () => {
        this.validateField("confirmPassword", value);
      });
    }
  };

  captchaRef = React.createRef();

  isReadOnly = () => this.state.permission === "READ" || isTestMode;

  guardWrite =
    (fn) =>
    (...args) => {
      if (isTestMode) {
        showToast("error", "Actions are disabled in Test Mode");
        return;
      }
      if (this.isReadOnly()) {
        showToast("error", "You need write access to perform this operation");
        return;
      }
      return fn(...args);
    };

  renderMenus = () => {
    this.setState({ showLoader: true });
    GetAllMenus()
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data;
          if (response.error != "0") {
            // showToast("error", response.error_msg);
          } else {
            this.setState({ menus: response.list });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  checkPasswordMatch = () => {
    let password = document.getElementById("password").value;
    let confirmPassword = document.getElementById("confirmPassword").value;
    let isMatched = null;
    if (password !== "" || confirmPassword !== "") {
      isMatched = password === confirmPassword;
    }
    this.setState({ isPasswordMatched: isMatched });
  };

  handleRedundantCheckboxClick = (id, type) => {
    if (type == "read") {
      const el = document.getElementById("writeAccessFor" + id);
      if (el) el.checked = false;
    } else {
      const el = document.getElementById("readAccessFor" + id);
      if (el) el.checked = false;
    }
  };

  handleRedundantCheckboxClickForEdit = (id, type) => {
    if (type == "read") {
      const el = document.getElementById("writeAccessEditFor" + id);
      if (el) el.checked = false;
    } else {
      const el = document.getElementById("readAccessEditFor" + id);
      if (el) el.checked = false;
    }
  };

  handleCreateSubMerchant = () => {
    if (isTestMode) {
      showToast("error", "Actions are disabled in Test Mode");
      return;
    }
    if (this.isReadOnly()) {
      showToast("error", "You need write access to perform this operation");
      return;
    }

    const { firstName, lastName, email, password, confirmPassword } = this.state;

    // Validate fields
    const isFirstNameValid = this.validateField("firstName", firstName);
    const isLastNameValid = this.validateField("lastName", lastName);
    const isEmailValid = this.validateField("email", email);
    const isPasswordValid = this.validateField("password", password);
    const isConfirmPasswordValid = this.validateField(
      "confirmPassword",
      confirmPassword
    );

    if (
      !isFirstNameValid ||
      !isLastNameValid ||
      !isEmailValid ||
      !isPasswordValid ||
      !isConfirmPasswordValid
    ) {
      showToast("error", "Please fix the errors before submitting");
      return;
    }

    let payload = {
      country: localStorage.getItem(SITENAMEALIAS + "_country"),
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      first_name: firstName,
      last_name: lastName,
      phone: this.state.phone,
      countryCode: this.state.dialCode,
      gender: this.state.gender,
      email: this.state.email,
      password: this.state.password,
    };
    payload["brokerId"] = localStorage.getItem(SITENAMEALIAS + "_brokerId");

    let access = [];
    document.querySelectorAll(".allmenu").forEach(function (elem) {
      let id = elem.getAttribute("data-id");
      let type = elem.getAttribute("data-type");
      let isChecked = elem.checked;
      if (isChecked) {
        let obj = { access: type.toUpperCase(), menu_id: id };
        access.push(obj);
      }
    });
    payload["access_list"] = access;
    this.setState({ showLoader: true });
    CreateSubMerchant(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Sub User added successfully");
            this.setState({
              showAddUserPopup: false,
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              password: "",
              confirmPassword: "",
              errors: {},
            });
            this.getAllSubMerchant();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleUpdateSubMerchant = () => {
    if (isTestMode) {
      showToast("error", "Actions are disabled in Test Mode");
      return;
    }
    if (this.isReadOnly()) {
      showToast("error", "You need write access to perform this operation");
      return;
    }
    let payload = {
      merchant_id: this.state.selectedSubMerchantId,
    };
    let access = [];
    document.querySelectorAll(".allEditMenu").forEach(function (elem) {
      let id = elem.getAttribute("data-id");
      let type = elem.getAttribute("data-type");
      let isChecked = elem.checked;
      if (isChecked) {
        let obj = { access: type.toUpperCase(), menu_id: id };
        access.push(obj);
      }
    });
    payload["access_list"] = access;
    this.setState({ showLoader: true });
    UpdateAccessLevel(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data;
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast("success", "Access updated successfully");
            this.setState({ showEditUserPopup: false });
            this.getAllSubMerchant();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleDeleteSubMerchant = async () => {
    if (isTestMode) {
      showToast("error", "Actions are disabled in Test Mode");
      return;
    }
    if (this.isReadOnly()) {
      showToast("error", "You need write access to perform this operation");
      return;
    }
    const merchant = this.state.selectedDeleteMerchant;
    if (!merchant) return;
    let token;
    try {
      const result = await this.captchaRef.current.verify();
      token = result.token;
    } catch (e) {
      showToast("error", "Captcha verification failed. Please try again.");
      return;
    }
    const payload = {
      uuid: merchant.uuid,
      gRecaptchaResponse: token,
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    RemoveSubMerchant(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          const response = Array.isArray(res.data) ? res.data[0] : res.data;
          if (response.error != 0) {
            showToast(
              "error",
              response.error_msg || "Something went wrong. Please try again."
            );
          } else {
            showToast(
              "success",
              response.error_msg || "User deleted successfully"
            );
            this.setState({
              showDeletePopup: false,
              selectedDeleteMerchant: null,
            });
            this.getAllSubMerchant();
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  getAllSubMerchant = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    GetSubMerchantList(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          var response = res.data;
          if (response.error != "0") {
            // showToast("error", response.error_msg);
          } else {
            this.setState({ subMerchants: response.list });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleViewDetails = (merchant) => {
    let accessList = merchant.access_list;
    this.setState(
      { showEditUserPopup: true, selectedSubMerchantId: merchant.merchant_id },
      () => {
        if (accessList.length >= 0) {
          for (let i = 0; i < accessList.length; i++) {
            if (accessList[i].access.toUpperCase() == "READ") {
              document.getElementById(
                "readAccessEditFor" + accessList[i].menu_id
              ).checked = true;
            } else {
              document.getElementById(
                "writeAccessEditFor" + accessList[i].menu_id
              ).checked = true;
            }
          }
        }
      }
    );
  };

  getAvatarColor = (index) => {
    return AVATAR_COLORS[index % AVATAR_COLORS.length];
  };

  getInitials = (firstName, lastName) => {
    return (
      (firstName || "").charAt(0) + (lastName || "").charAt(0)
    ).toUpperCase();
  };

  componentDidMount() {
    this.setState({ permission: currentPageAccess() });
    this.renderMenus();
    this.getAllSubMerchant();
  }

  renderSortedMenus = () => {
    return [...this.state.menus].sort((a, b) => {
      if (a.id === 10) return -1;
      if (b.id === 10) return 1;
      return 0;
    });
  };

  renderPermissionTable = (mode) => {
    const isEdit = mode === "edit";
    const checkboxClass = isEdit ? "allEditMenu" : "allmenu";
    const idPrefix = isEdit ? "AccessEditFor" : "AccessFor";
    const handleClick = isEdit
      ? this.handleRedundantCheckboxClickForEdit
      : this.handleRedundantCheckboxClick;

    return (
      <div style={styles.permissionSection}>
        <div style={styles.permissionLabel}>
          <i className="fa fa-shield-alt" style={{ opacity: 0.5 }}></i>
          Access Permissions
        </div>
        <table style={styles.permissionTable}>
          <thead>
            <tr>
              <th style={styles.permTh}>Menu</th>
              <th style={{ ...styles.permTh, textAlign: "center" }}>Read</th>
              <th style={{ ...styles.permTh, textAlign: "center" }}>Write</th>
            </tr>
          </thead>
          <tbody>
            {this.renderSortedMenus().map((menu) => (
              <tr key={menu.id}>
                <td style={{ ...styles.permTd, ...styles.permTdFirst }}>
                  {menu.name}
                </td>
                <td style={{ ...styles.permTd, textAlign: "center" }}>
                  {menu.name == "Get Started" && !isEdit ? (
                    <input
                      type="checkbox"
                      id={"read" + idPrefix + menu.id}
                      className={checkboxClass}
                      data-type="read"
                      data-id={menu.id}
                      style={styles.checkbox}
                      onClick={() => handleClick(menu.id, "read")}
                      checked
                    />
                  ) : (
                    <input
                      type="checkbox"
                      id={"read" + idPrefix + menu.id}
                      className={checkboxClass}
                      data-type="read"
                      data-id={menu.id}
                      style={styles.checkbox}
                      onClick={() => handleClick(menu.id, "read")}
                    />
                  )}
                </td>
                <td
                  style={{
                    ...styles.permTd,
                    ...styles.permTdLast,
                    textAlign: "center",
                  }}
                >
                  {menu.name !== "User Management" && (
                    <input
                      type="checkbox"
                      id={"write" + idPrefix + menu.id}
                      className={checkboxClass}
                      data-type="write"
                      data-id={menu.id}
                      style={styles.checkbox}
                      onClick={() => handleClick(menu.id, "write")}
                    />
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  render() {
    return (
      <Fragment>
        <style>{`
          .um-delete-btn {
            background: #ef4444 !important;
            color: #fff !important;
            border-color: #ef4444 !important;
          }
          .um-delete-btn:hover {
            background: #dc2626 !important;
          }
        `}</style>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Page Header */}
              <div style={styles.pageHeader}>
                <PageHeader
                  icon="mdi-account-supervisor"
                  title="User Management"
                  subtitle={
                    isTestMode
                      ? "View-only mode (Test Mode active)"
                      : "Manage sub-user and access permissions"
                  }
                />
                <button
                  type="button"
                  disabled={this.isReadOnly()}
                  style={{
                    ...styles.addButton,
                    ...(this.isReadOnly()
                      ? { opacity: 0.5, cursor: "not-allowed" }
                      : {}),
                  }}
                  onClick={this.guardWrite(() =>
                    this.setState({ showAddUserPopup: true })
                  )}
                  onMouseEnter={(e) => {
                    if (this.isReadOnly()) return;
                    e.target.style.transform = "translateY(-1px)";
                    e.target.style.boxShadow =
                      "0 4px 16px color-mix(in srgb, var(--btn-color), transparent 45%)";
                  }}
                  onMouseLeave={(e) => {
                    if (this.isReadOnly()) return;
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow =
                      "0 2px 8px color-mix(in srgb, var(--btn-color), transparent 60%)";
                  }}
                >
                  <i className="fa fa-plus" style={{ fontSize: "12px" }}></i>
                  Add User
                </button>
              </div>

              {/* Users Table */}
              <div style={styles.tableCard}>
                <div style={styles.tableCardHeader}>
                  <h4 style={styles.tableCardTitle}>Sub-User Accounts</h4>
                </div>
                <div style={styles.tableWrapper}>
                  {this.state.subMerchants.length === 0 ? (
                    <div style={styles.emptyState}>
                      <div style={styles.emptyIcon}>
                        <i className="fa fa-user-friends"></i>
                      </div>
                      <div style={styles.emptyText}>No sub-merchants found</div>
                    </div>
                  ) : (
                    <table style={styles.table}>
                      <thead>
                        <tr>
                          <th style={styles.th}>Name</th>
                          <th style={styles.th}>Email</th>
                          <th style={styles.th}>Phone</th>
                          <th style={styles.th}>Status</th>
                          <th style={{ ...styles.th, textAlign: "right" }}>
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.subMerchants
                          .filter((m) => m.account_status_id !== 40)
                          .map((merchant, index) => (
                            <tr
                              key={merchant.merchant_id}
                              style={{ transition: "background 0.15s ease" }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background =
                                  "color-mix(in srgb, var(--text-color), transparent 96%)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background =
                                  "transparent";
                              }}
                            >
                              <td style={styles.td}>
                                <div style={styles.nameCell}>
                                  <div
                                    style={{
                                      ...styles.avatar,
                                      background: this.getAvatarColor(index),
                                    }}
                                  >
                                    {this.getInitials(
                                      merchant.first_name,
                                      merchant.last_name
                                    )}
                                  </div>
                                  <span style={styles.nameText}>
                                    {merchant.first_name} {merchant.last_name}
                                  </span>
                                </div>
                              </td>
                              <td style={styles.td}>
                                <span style={styles.emailText}>
                                  {merchant.email}
                                </span>
                              </td>
                              <td style={styles.td}>
                                <span style={styles.phoneText}>
                                  +{merchant.phone}
                                </span>
                              </td>
                              <td style={styles.td}>
                                <span
                                  style={styles.statusBadge(
                                    merchant.account_status_id
                                  )}
                                >
                                  {STATUS_MAP[merchant.account_status_id] ||
                                    "Unknown"}
                                </span>
                              </td>
                              <td style={{ ...styles.td, textAlign: "right" }}>
                                <button
                                  type="button"
                                  disabled={this.isReadOnly()}
                                  style={{
                                    ...styles.viewBtn,
                                    ...(this.isReadOnly()
                                      ? { opacity: 0.5, cursor: "not-allowed" }
                                      : {}),
                                  }}
                                  onClick={this.guardWrite(() =>
                                    this.handleViewDetails(merchant)
                                  )}
                                  onMouseEnter={(e) => {
                                    if (this.isReadOnly()) return;
                                    e.target.style.background =
                                      "color-mix(in srgb, var(--btn-color), transparent 80%)";
                                  }}
                                  onMouseLeave={(e) => {
                                    if (this.isReadOnly()) return;
                                    e.target.style.background =
                                      "color-mix(in srgb, var(--btn-color), transparent 90%)";
                                  }}
                                >
                                  <i
                                    className="fa fa-eye"
                                    style={{ fontSize: "12px" }}
                                  ></i>
                                  Details
                                </button>
                                <button
                                  type="button"
                                  disabled={this.isReadOnly()}
                                  className="um-delete-btn"
                                  style={{
                                    ...styles.deleteBtn,
                                    ...(this.isReadOnly()
                                      ? { opacity: 0.5, cursor: "not-allowed" }
                                      : {}),
                                  }}
                                  onClick={this.guardWrite(() =>
                                    this.setState({
                                      showDeletePopup: true,
                                      selectedDeleteMerchant: merchant,
                                    })
                                  )}
                                >
                                  <i
                                    className="fa fa-trash"
                                    style={{ fontSize: "12px" }}
                                  ></i>
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>

        {/* Add User Modal */}
        {this.state.showAddUserPopup && (
          <div style={styles.modalOverlay}>
            <div
              style={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.modalHeader}>
                <div style={styles.modalIconBadge("#10b981")}>
                  <i className="fa fa-user-plus"></i>
                </div>
                <div>
                  <h5 style={styles.modalTitle}>Add New Sub User</h5>
                  <p style={styles.modalSubtitle}>
                    Create a new sub-user with custom permissions
                  </p>
                </div>
              </div>
              <div style={styles.modalBody}>
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    marginBottom: "18px",
                    alignItems: "flex-end",
                  }}
                >
                  <div style={{ flex: "0 0 100px" }}>
                    <label style={styles.formLabel}>Gender</label>
                    <select
                      value={this.state.gender}
                      onChange={(e) =>
                        this.setState({ gender: e.target.value })
                      }
                      style={{ ...styles.formInput, cursor: "pointer" }}
                    >
                      <option value="Male">Mr.</option>
                      <option value="Female">Mrs.</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={styles.formLabel}>First Name</label>
                    <input
                      type="text"
                      placeholder="First Name *"
                      style={{
                        ...styles.formInput,
                        borderColor: this.state.errors.firstName
                          ? "#ef4444"
                          : styles.formInput.borderColor,
                      }}
                      value={this.state.firstName}
                      onChange={this.handleFirstNameChange}
                      onFocus={(e) => {
                        if (!this.state.errors.firstName)
                          e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        if (!this.state.errors.firstName) {
                          e.target.style.borderColor =
                            "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }
                      }}
                    />
                    {this.state.errors.firstName && (
                      <span
                        style={{
                          color: "#ef4444",
                          fontSize: "11px",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {this.state.errors.firstName}
                      </span>
                    )}
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={styles.formLabel}>Last Name</label>
                    <input
                      type="text"
                      placeholder="Last Name *"
                      style={{
                        ...styles.formInput,
                        borderColor: this.state.errors.lastName
                          ? "#ef4444"
                          : styles.formInput.borderColor,
                      }}
                      value={this.state.lastName}
                      onChange={this.handleLastNameChange}
                      onFocus={(e) => {
                        if (!this.state.errors.lastName)
                          e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        if (!this.state.errors.lastName) {
                          e.target.style.borderColor =
                            "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }
                      }}
                    />
                    {this.state.errors.lastName && (
                      <span
                        style={{
                          color: "#ef4444",
                          fontSize: "11px",
                          marginTop: "4px",
                          display: "block",
                        }}
                      >
                        {this.state.errors.lastName}
                      </span>
                    )}
                  </div>
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Email</label>
                  <input
                    type="email"
                    placeholder="Enter email address"
                    style={{
                      ...styles.formInput,
                      borderColor: this.state.errors.email
                        ? "#ef4444"
                        : styles.formInput.borderColor,
                    }}
                    value={this.state.email}
                    onChange={this.handleEmailChange}
                    onFocus={(e) => {
                      if (!this.state.errors.email)
                        e.target.style.borderColor = "var(--btn-color)";
                    }}
                    onBlur={(e) => {
                      if (!this.state.errors.email) {
                        e.target.style.borderColor =
                          "color-mix(in srgb, var(--text-color), transparent 85%)";
                      }
                    }}
                  />
                  {this.state.errors.email && (
                    <span
                      style={{
                        color: "#ef4444",
                        fontSize: "11px",
                        marginTop: "4px",
                        display: "block",
                      }}
                    >
                      {this.state.errors.email}
                    </span>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Phone</label>
                  <PhoneInput
                    placeholder="Enter phone number"
                    country={this.state.selectedCountry}
                    disableCountryGuess={true}
                    countryCodeEditable={false}
                    onChange={function (value, country) {
                      const dialCode = country.dialCode;
                      let localNumber = value;
                      if (value.startsWith(dialCode)) {
                        localNumber = value.slice(dialCode.length);
                      }
                      this.setState({
                        phone: localNumber,
                        selectedCountry: country.name,
                        dialCode: dialCode,
                      });
                    }.bind(this)}
                    inputStyle={{
                      width: "100%",
                      padding: "11px 16px 11px 52px",
                      borderRadius: "10px",
                      border:
                        "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
                      background: "var(--body-color-less2)",
                      color: "var(--text-color)",
                      fontSize: "14px",
                      height: "auto",
                    }}
                    buttonStyle={{
                      borderRadius: "10px 0 0 10px",
                      border:
                        "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
                      background: "var(--body-color-less2)",
                    }}
                    dropdownStyle={{
                      background: "var(--body-color-less)",
                      color: "var(--text-color)",
                      borderRadius: "10px",
                      border:
                        "1px solid color-mix(in srgb, var(--text-color), transparent 85%)",
                    }}
                  />
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Password</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={this.state.showPassword ? "text" : "password"}
                      placeholder="Enter password"
                      style={{
                        ...styles.formInput,
                        paddingRight: "42px",
                        borderColor: this.state.errors.password
                          ? "#ef4444"
                          : styles.formInput.borderColor,
                      }}
                      value={this.state.password}
                      onChange={this.handlePasswordChange}
                      onFocus={(e) => {
                        if (!this.state.errors.password)
                          e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        if (!this.state.errors.password) {
                          e.target.style.borderColor =
                            "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }
                      }}
                    />
                    <i
                      className={
                        this.state.showPassword
                          ? "fa fa-eye-slash"
                          : "fa fa-eye"
                      }
                      onClick={() =>
                        this.setState({
                          showPassword: !this.state.showPassword,
                        })
                      }
                      style={{
                        position: "absolute",
                        right: "14px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "var(--text-color)",
                        opacity: 0.45,
                        fontSize: "14px",
                      }}
                    ></i>
                  </div>
                  {this.state.errors.password && (
                    <span
                      style={{
                        color: "#ef4444",
                        fontSize: "11px",
                        marginTop: "4px",
                        display: "block",
                        lineHeight: "1.4",
                      }}
                    >
                      {this.state.errors.password}
                    </span>
                  )}
                </div>
                <div style={styles.formGroup}>
                  <label style={styles.formLabel}>Confirm Password</label>
                  <div style={{ position: "relative" }}>
                    <input
                      type={
                        this.state.showConfirmPassword ? "text" : "password"
                      }
                      placeholder="Re-enter password"
                      style={{
                        ...styles.formInput,
                        paddingRight: "42px",
                        borderColor: this.state.errors.confirmPassword
                          ? "#ef4444"
                          : styles.formInput.borderColor,
                      }}
                      value={this.state.confirmPassword}
                      onChange={this.handleConfirmPasswordChange}
                      onFocus={(e) => {
                        if (!this.state.errors.confirmPassword)
                          e.target.style.borderColor = "var(--btn-color)";
                      }}
                      onBlur={(e) => {
                        if (!this.state.errors.confirmPassword) {
                          e.target.style.borderColor =
                            "color-mix(in srgb, var(--text-color), transparent 85%)";
                        }
                      }}
                    />
                    <i
                      className={
                        this.state.showConfirmPassword
                          ? "fa fa-eye-slash"
                          : "fa fa-eye"
                      }
                      onClick={() =>
                        this.setState({
                          showConfirmPassword: !this.state.showConfirmPassword,
                        })
                      }
                      style={{
                        position: "absolute",
                        right: "14px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "var(--text-color)",
                        opacity: 0.45,
                        fontSize: "14px",
                      }}
                    ></i>
                  </div>
                  {this.state.errors.confirmPassword && (
                    <span
                      style={{
                        color: "#ef4444",
                        fontSize: "11px",
                        marginTop: "4px",
                        display: "block",
                      }}
                    >
                      {this.state.errors.confirmPassword}
                    </span>
                  )}
                </div>
                {this.state.isPasswordMatched !== null &&
                  (this.state.isPasswordMatched ? (
                    <div
                      style={{
                        ...styles.passwordMatch,
                        color: "#10b981",
                        background:
                          "color-mix(in srgb, #10b981, transparent 90%)",
                      }}
                    >
                      <i className="fa fa-check-circle"></i> Passwords match
                    </div>
                  ) : (
                    <div
                      style={{
                        ...styles.passwordMatch,
                        color: "#ef4444",
                        background:
                          "color-mix(in srgb, #ef4444, transparent 90%)",
                      }}
                    >
                      <i className="fa fa-times-circle"></i> Passwords do not
                      match
                    </div>
                  ))}
                {this.renderPermissionTable("add")}
              </div>
              <div style={styles.modalFooter}>
                <button
                  type="button"
                  style={styles.btnCancel}
                  onClick={() =>
                    this.setState({
                      showAddUserPopup: false,
                      isPasswordMatched: null,
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={styles.btnPrimary}
                  onClick={() => this.handleCreateSubMerchant()}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <i
                    className="fa fa-plus"
                    style={{ marginRight: "6px", fontSize: "12px" }}
                  ></i>
                  Create Sub-User
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Delete Confirmation Modal */}
        {this.state.showDeletePopup && (
          <div style={styles.modalOverlay}>
            <div
              style={{ ...styles.modalContent, maxWidth: "440px" }}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.modalHeader}>
                <div style={styles.modalIconBadge("#ef4444")}>
                  <i className="fa fa-trash"></i>
                </div>
                <div>
                  <h5 style={styles.modalTitle}>Delete Sub-User</h5>
                  <p style={styles.modalSubtitle}>
                    This action is permanent and cannot be undone
                  </p>
                </div>
              </div>
              <div style={styles.modalBody}>
                <p
                  style={{
                    fontSize: "14px",
                    color: "var(--text-color)",
                    lineHeight: "1.6",
                    margin: 0,
                  }}
                >
                  Are you sure you want to delete{" "}
                  <strong>
                    {this.state.selectedDeleteMerchant?.first_name}{" "}
                    {this.state.selectedDeleteMerchant?.last_name}
                  </strong>
                  ? All data associated with this account will be permanently
                  removed.
                </p>
                <div
                  style={{
                    marginTop: "16px",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    background: "color-mix(in srgb, #ef4444, transparent 92%)",
                    border:
                      "1px solid color-mix(in srgb, #ef4444, transparent 75%)",
                    fontSize: "13px",
                    color: "#ef4444",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <i className="fa fa-exclamation-triangle"></i>
                  Click &quot;Confirm Delete&quot; to complete captcha
                  verification and delete the user.
                </div>
              </div>
              <div style={styles.modalFooter}>
                <button
                  type="button"
                  style={styles.btnCancel}
                  onClick={() =>
                    this.setState({
                      showDeletePopup: false,
                      selectedDeleteMerchant: null,
                    })
                  }
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={{
                    ...styles.btnPrimary,
                    background: "#ef4444",
                    boxShadow:
                      "0 2px 8px color-mix(in srgb, #ef4444, transparent 60%)",
                  }}
                  onClick={() => this.handleDeleteSubMerchant()}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <i
                    className="fa fa-trash"
                    style={{ marginRight: "6px", fontSize: "12px" }}
                  ></i>
                  Confirm Delete
                </button>
              </div>
            </div>
          </div>
        )}

        <PaybitoCaptcha ref={this.captchaRef} />

        {/* Edit Access Modal */}
        {this.state.showEditUserPopup && (
          <div style={styles.modalOverlay}>
            <div
              style={styles.modalContent}
              onClick={(e) => e.stopPropagation()}
            >
              <div style={styles.modalHeader}>
                <div style={styles.modalIconBadge("#3b82f6")}>
                  <i className="fa fa-user-edit"></i>
                </div>
                <div>
                  <h5 style={styles.modalTitle}>Edit Access</h5>
                  <p style={styles.modalSubtitle}>
                    Update menu permissions for this sub-user
                  </p>
                </div>
              </div>
              <div style={styles.modalBody}>
                {this.renderPermissionTable("edit")}
              </div>
              <div style={styles.modalFooter}>
                <button
                  type="button"
                  style={styles.btnCancel}
                  onClick={() => this.setState({ showEditUserPopup: false })}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  style={styles.btnPrimary}
                  onClick={() => this.handleUpdateSubMerchant()}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  <i
                    className="fa fa-save"
                    style={{ marginRight: "6px", fontSize: "12px" }}
                  ></i>
                  Update Access
                </button>
              </div>
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

export default UserManagement;
